export default {
	data() {
		return {
			filterColor: ""
		};
	},
	watch: {
		filterColor: {
			handler(val) {
				let fieldName = "color";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "string", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	}
};
